import { TemplateEngine } from "../../../js/lib/TemplateEngine";
import { EventQueue } from "../../../js/lib/events/EventQueue";
import { LS2KIDS_CONSTANTS } from "./constants";
import { KidsCategoryManager } from "./managers/categoryManager";

/**
 * formerly known as tlc.ls2kids.loader
 */
export class KidsLoader {
	constructor() { }
	/**
	 * Start firing the array of events and start resolving them as needed.
	 *
	 * @param {Array.<string>} events an array of events that should fire.
	 * @return {jQuery.Promise}
	 */
	static start(events) {
		KidsLoader._progressElement = $('#' + LS2KIDS_CONSTANTS.Ids.progressBar);
		KidsLoader._progressBarElement = KidsLoader._progressElement.find('.bar');

		KidsLoader._events = events;

		events.push({ funcWithCallback: KidsLoader._preloadNextTemplate });

		EventQueue.createQueue(
			events,
			//		function() {},
			KidsLoader._eventQueueFinished,
			KidsLoader._progressUpdate
		);

		KidsLoader._deferred = $.Deferred();

		return KidsLoader._deferred.promise();
	}
	/**
	 * Callback from when the event queue is finished. Resolve our promise here.
	 *
	 * @private
	 */
	static _eventQueueFinished() {
		KidsLoader._deferred.resolve();

		window.requestAnimationFrame(function () {
			$('#' + LS2KIDS_CONSTANTS.Ids.mainLoader).remove();
		});
	}
	/**
	 * A callback from the event queue when a single event has been completed.
	 *
	 * @param {number} progress a percentage as to how much is finished
	 * @param {number} total the total number of events that we are still waiting on
	 * @param {number} current the total amount of events that have been completed
	 * @private
	 */
	static _progressUpdate(progress, total, current) {

		KidsLoader._progressBarElement.css({
			width: ((current / total) * 100) + "%"
		});
	}
	static _preloadNextTemplate(callback) {
		//	KidsLoader._secondaryProgressbarElement.progressbar( 'value', 0 );
		//	KidsLoader._secondaryProgressbarElement.show();
		var nextTemplate = KidsLoader._preloadTemplates[KidsLoader._preloadTemplateIndex];
		TemplateEngine.fetch(
			nextTemplate,
			null,
			null,
			function () {
				KidsLoader._preloadTemplateIndex++;
				//			KidsLoader._secondaryProgressbarElement.progressbar( 'value', KidsLoader._preloadTemplateIndex );
				if (KidsLoader._preloadTemplateIndex == KidsLoader._preloadTemplates.length) {
					callback();
				} else {
					KidsLoader._preloadNextTemplate(callback);
				}
			}
		);
	}
	static _initPreloadCategoryImages(callback) {
		var categories = KidsCategoryManager.getCategories();

		//	KidsLoader._secondaryProgressbarElement.progressbar( 'value', 0 );
		//	KidsLoader._secondaryProgressbarElement.progressbar( 'option', 'max', categories.length );
		for (var i = 0, len = categories.length; i < len; i += 1) {
			var category = categories[i];
			var categoryImage = LS2KIDS_CONSTANTS.restUrls.category.onImage(category.id);

			KidsLoader._preloadImages.push(categoryImage);
		}

		KidsLoader._preloadCategoryImages(callback);
	}
	static _preloadCategoryImages(callback) {
		var nextImage = KidsLoader._preloadImages[KidsLoader._preloadCategoryIndex];

		var image = new Image();

		image.onload = function () {
			KidsLoader._preloadCategoryIndex++;

			//		KidsLoader._secondaryProgressbarElement.progressbar( 'value', KidsLoader._preloadCategoryIndex );
			if (KidsLoader._preloadImages.length <= KidsLoader._preloadCategoryIndex) {
				callback();
			} else {
				KidsLoader._preloadCategoryImages(callback);
			}
		};

		image.src = nextImage;
	}
}

/**
 * The progress bar element.
 *
 * @type {jQuery}
 * @private
 */
KidsLoader._progressbarElement = null;

/**
 * The progress bar element.
 *
 * @type {jQuery}
 * @private
 */
KidsLoader._progressbarAssetsElement = null;

/**
 * The jQuery Promise object that will get resolved when the loader is complete.
 *
 * @type {jQuery.Promise}
 * @private
 */
KidsLoader._deferred = null;

/**
 * The template index the preloader is currently up to.
 * @type {number}
 * @private
 */
KidsLoader._preloadTemplateIndex = 0;


/**
 * The template index the preloader is currently up to.
 * @type {number}
 * @private
 */
KidsLoader._preloadCategoryIndex = 0;

/**
 * The templates we should preload.
 * @type {Array.<string>}
 * @private
 */
KidsLoader._preloadTemplates = [
	'tmpl/kids/category/categoryView.html',
	'tmpl/kids/series/seriesView.html',
	'tmpl/kids/headerView.html',
	'tmpl/kids/footerView.html',
	'tmpl/kids/results/resultItem.html',
	'tmpl/kids/results/resultsView.html',
	'tmpl/kids/messageView.html',
	'tmpl/kids/results/titles_fullDetails_marcData.html'
];

/**
 * The templates we should preload.
 * @type {Array.<string>}
 * @private
 */
KidsLoader._preloadImages = [
	"images/kids/glass.png"
];








